// This is the magic string used to treat global admin as any other
// access right. This needs to either be unique amongst all other access
// rights in the database, or be replaced by some other means of determining
// if something is restricted to just global admins.
export const GlobalAdminAccessRight = "_GlobalAdmin";
export const FarmAdminAccessRight = "_FarmAdmin";
